<template>
  <div class="w-full lg:w-1/3 lg:pl-6">
    <div class="border border-grey-light mb-6">
      <div class="w-full flex text-sm p-4 bg-grey-lighter border-t-2 border-print-order-teal">
        <strong class="h-6">Item Summary</strong>
      </div>
      <div v-if="stage !== 2" class="pt-4 px-4 leading-normal">
        <table v-if="orderItem.quantity > 0 && subtotal > 0" class="w-full">
          <tbody class="border-b border-grey-light">
            <tr v-if="selectedSpecification">
              <td class="text-sm font-bold pb-3 pr-3">{{ categoryName + ' - ' + productName + ' x ' + orderItem.quantity }}</td>
              <td class="text-right pb-3 text-sm">{{ selectedSpecification.price | gbp }}</td>
            </tr>
            <tr>
              <td class="text-sm pb-6 pr-3">
                <ul>
                  <li v-for="(specValue, i) in filteredSpec" :key="i"><span class="capitalize">{{ titleFormat(i) }}</span>: {{ specValue }}</li>
                </ul>
              </td>
              <td></td>
            </tr>
            <tr v-if="artwork && artwork.price && orderItem.artwork_type_id === 1">
              <td class="text-sm font-bold pb-3 pr-3">{{ artwork.name }}</td>
              <td class="text-right pb-3 text-sm">{{ artwork.price | gbp }}</td>
            </tr>
            <tr v-if="delivery && delivery.price">
              <td class="text-sm font-bold pb-6 pr-3">{{ delivery.name }}</td>
              <td class="text-right pb-6 text-sm">{{ delivery.price | gbp }}</td>
            </tr>
          </tbody>
        </table>
        <table v-else class="w-full">
          <tbody class="border-b border-grey-light">
            <tr><td colspan="2" class="align-top text-sm pt-3">-</td></tr>
            <tr>
              <td class="align-top text-xs pb-3 pr-3">-</td>
              <td class="align-bottom text-right pb-3 text-sm">£0.00</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="px-4 pt-6">
        <h4 class="block text-sm pb-3">Total</h4>
        <table class="w-full mb-4">
          <tbody>
            <tr>
              <td class="align-top text-sm pb-2">
                Subtotal
              </td>
              <td class="align-top text-right text-sm pb-2">{{ subtotal | gbp }}</td>
            </tr>
            <tr v-if="vat > 0">
              <td class="align-top text-sm pb-3">
                VAT (20%)
              </td>
              <td class="align-top text-right text-sm pb-3">{{ vat | gbp }}</td>
            </tr>
            <tr>
              <td class="align-top text-sm font-bold pb-1">
                Total
              </td>
              <td class="align-top text-right text-sm font-bold pb-1">{{ total | gbp }}</td>
            </tr>
            <tr v-if="additionalDelivery">
              <td colspan="2" class="align-top text-right text-sm pb-2">+ unknown delivery charge</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="stage === 1" class="w-full mb-6">
      <div class="px-4">
        <!-- <p class="mt-4 mb-6 text-xs leading-normal">Please note that you are about to submit your order and confirm that the details you have entered are correct. Changes to your order made after this point may not be possible and/or may be subject to an administration charge.</p> -->
        <div v-if="subtotal >= 0" class="text-center">
          <button class="w-full md:w-3/4 mb-6 py-4 text-xs border border-print-order-teal bg-print-order-teal-lightest hover:bg-print-order-teal text-print-order-teal hover:text-white focus:outline-none" @click="$emit('addToBasket')">{{ basketButtonText }}</button>
          <button v-if="orderItem.status_id !== 1" class="w-full md:w-3/4 mb-6 py-4 text-xs border border-grey-light bg-white hover:bg-grey-lighter text-grey-dark focus:outline-none" @click="$emit('saveItem')">Save Item &gt;&gt;</button>
          <button class="w-full md:w-3/4 py-4 text-xs border border-grey-light bg-white hover:bg-grey-lighter text-grey-dark focus:outline-none" @click="$emit('previousStep')">&lt;&lt; Back</button>
        </div>
      </div>
    </div>
    <div v-else class="w-full p-4 mb-6 text-center">
      <button type="button" class="py-4 px-20 text-xs border border-print-order-teal bg-print-order-teal-lightest hover:bg-print-order-teal text-print-order-teal hover:text-white focus:outline-none" @click="$emit('nextStep')">
        {{ stage === 0 ? 'Artwork & Notes &gt;&gt;' : 'Next Step &gt;&gt;' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loaded: true
    }
  },
  props: ['stage', 'orderItem', 'categoryName', 'productName', 'selectedSpecification', 'artwork', 'delivery', 'additionalDelivery', 'subtotal', 'vat', 'total'],
  computed: {
    filteredSpec () {
      let filtered = {}
      let keys = Object.keys(this.orderItem.specification)
      for (let i = 0; i < keys.length; i++) {
        if (this.orderItem.specification[keys[i]] !== null) {
          filtered[keys[i]] = this.orderItem.specification[keys[i]]
        }
      }
      return filtered
    },
    basketButtonText () {
      let buttonText = this.orderItem.status_id === 1 ? 'Save' : 'Add'

      return buttonText + ' To Basket >>'
    }
  },
  methods: {
    titleFormat (string) {
      return string.replace(new RegExp('_', 'g'), ' ')
    }
  }
}
</script>
